/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum HorizontalLayoutOption {
    Left = 0,
    Center = 1,
    Right = 2,
    Stretch = 3,
}
